import { useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";

const LAYER_EXTRUDE_DEM = ({ layer, genangan_reducer }) => {
  const clickHandlerRef = useRef(null);

  const handleExtrusionClick = useCallback(async (e) => {
    try {
      if (!e) {
        throw new Error("Event object is missing");
      }
      if (!e.features || e.features.length === 0) {
        return;
      }
      const feature = e.features[0];
      if (!feature) {
        throw new Error("Feature data is invalid");
      }
      if (!feature.properties) {
        throw new Error("Feature properties are missing");
      }

      const value = feature.properties.VALUE;
      if (value === undefined || value === null) {
        throw new Error("Elevation VALUE property is missing");
      }
    } catch (error) {}
  }, []);

  const on_render = useCallback(async () => {
    try {
      const { map_object } = layer;
      if (!map_object) {
        throw new Error("Map object is not available");
      }
      const geojson_grid_elevation = genangan_reducer.geojson_grid_elevation;
      const min_mdpl = genangan_reducer.min_mdpl;
      const max_mdpl = genangan_reducer.max_mdpl;
      const enlarge_extrude = genangan_reducer.enlarge_extrude;
      const visibility_extrude = genangan_reducer.visibility_extrude;

      if (!geojson_grid_elevation) {
        throw new Error("GeoJSON grid elevation data is missing");
      }
      const range = max_mdpl - min_mdpl;
      const step = range / 4;
      const color_stops = [
        min_mdpl,
        "#c2281c",
        min_mdpl + step * 1,
        "#cf3f37",
        min_mdpl + step * 2,
        "#f4a73d",
        min_mdpl + step * 3,
        "#f9d94a",
        max_mdpl,
        "#4f983e",
      ];
      try {
        if (!map_object.getSource("geojson_grid_elevation")) {
          map_object.addSource("geojson_grid_elevation", {
            type: "geojson",
            data: geojson_grid_elevation,
            tolerance: 0,
          });
        } else {
          const source = map_object.getSource("geojson_grid_elevation");
          if (source) {
            source.setData(geojson_grid_elevation);
          }
        }
      } catch (sourceError) {
        throw new Error(`Failed to add/update source: ${sourceError.message}`);
      }
      try {
        if (!map_object.getLayer("geojson_grid_elevation_extrude")) {
          map_object.addLayer({
            id: "geojson_grid_elevation_extrude",
            source: "geojson_grid_elevation",
            type: "fill-extrusion",
            paint: {
              "fill-extrusion-color": [
                "interpolate",
                ["linear"],
                ["get", "VALUE"],
                ...color_stops,
              ],
              "fill-extrusion-height": [
                "*",
                ["-", ["get", "VALUE"], min_mdpl],
                enlarge_extrude,
              ],
              "fill-extrusion-base": 0,
              "fill-extrusion-opacity": 1,
            },
            layout: {
              visibility: visibility_extrude,
            },
          });
          if (clickHandlerRef.current) {
            map_object.off(
              "click",
              "geojson_grid_elevation_extrude",
              clickHandlerRef.current
            );
          }
          clickHandlerRef.current = handleExtrusionClick;
          map_object.on(
            "click",
            "geojson_grid_elevation_extrude",
            handleExtrusionClick
          );
          map_object.on("mouseenter", "geojson_grid_elevation_extrude", () => {
            map_object.getCanvas().style.cursor = "pointer";
          });
          map_object.on("mouseleave", "geojson_grid_elevation_extrude", () => {
            map_object.getCanvas().style.cursor = "";
          });
        } else {
          map_object.setPaintProperty(
            "geojson_grid_elevation_extrude",
            "fill-extrusion-color",
            ["interpolate", ["linear"], ["get", "VALUE"], ...color_stops]
          );

          map_object.setPaintProperty(
            "geojson_grid_elevation_extrude",
            "fill-extrusion-height",
            ["*", ["-", ["get", "VALUE"], min_mdpl], enlarge_extrude]
          );

          map_object.setLayoutProperty(
            "geojson_grid_elevation_extrude",
            "visibility",
            visibility_extrude
          );
        }
      } catch (layerError) {
        throw new Error(`Failed to add/update layer: ${layerError.message}`);
      }
    } catch (error) {}
  }, [layer, genangan_reducer, handleExtrusionClick]);

  useEffect(() => {
    const { map_object } = layer;
    if (map_object) {
      on_render();
    }
    return () => {
      if (map_object && clickHandlerRef.current) {
        map_object.off(
          "click",
          "geojson_grid_elevation_extrude",
          clickHandlerRef.current
        );
        map_object.off("mouseenter", "geojson_grid_elevation_extrude");
        map_object.off("mouseleave", "geojson_grid_elevation_extrude");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    genangan_reducer.genangan_update,
    genangan_reducer.enlarge_extrude,
    genangan_reducer.visibility_extrude,
  ]);

  return <main />;
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  properties: state.properties,
  genangan_reducer: state.genangan_reducer,
});

export default connect(mapStateToProps, {})(LAYER_EXTRUDE_DEM);
